/** Created by azhou on 2019/3/14.*/
<template>
    <div id="addEditPosition">
      <public-title>添加职位
        <span class="text-link ml-auto h6" slot="right" @click="$router.push({name: 'PositionManage',query:{tab:$route.query.active}})">返回列表</span>
      </public-title>
      <div class="bg-white p-5">
        <left-text-border class="mb-2" leftText="职位名称" v-model="name" required placeholder="如：部门经理"/>
        <div class="d-center-start mb-2" v-if="userInfo.type===99 && positionId">
          <left-text leftText="是否禁用"/>
          <el-radio v-model="is_forbidden" label="1">是</el-radio>
          <el-radio v-model="is_forbidden" label="0">否</el-radio>
        </div>
        <left-text-border class="mb-2" leftText="职位描述" v-model="remarks" placeholder="如：负责该部门销售业务"/>
        <div class="d-center-start mb-2"  v-if="userInfo.type===99">
          <left-text leftText="所属身份" required/>
          <el-radio-group v-model="type">
            <el-radio :label="item.value" v-for="item in typeLists" :key="item.title">{{item.title}}</el-radio>
          </el-radio-group>
        </div>
        <div class="d-start-start mb-2">
          <left-text leftText="职位权限" required/>
          <el-tree :data= "accessLists" show-checkbox node-key="id"
                   ref="tree" :props="defaultProps" :default-expand-all="Boolean(positionId)"/>
        </div>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'

  export default {
    name: 'addEditPosition',
    data() {
      return {
        name: '',
        remarks: '',
        is_forbidden:'0',        //管理员职位管理是否禁用
        positionArr: [],         //选中的职位权限数组
        typeLists: [
          {title: '管理员', value: '1'},
          {title: '采购商', value: '2'},
          {title: '酒店', value: '3'},
          {title: '导游', value: '4'},
          {title: '民宿', value: '5'},
          {title: '景区', value: '6'},
          {title: '品牌馆', value: '8'},
        ],
        status: '0',
        type:'',
        defaultProps: {
          children:'children',
          label: 'title'
        }
      }
    },
    computed: {
      ...mapState(['accessLists','positionDetail']),
      ...mapGetters(['userInfo']),
      positionId() { return this.$route.query.position }
    },
    watch: {
      'type': function () {
        this.getUserAccessLists({type:this.type});
      },
      positionDetail(newVal) {
        this.name = newVal.name;
        this.remarks = newVal.remarks;
        this.is_forbidden = newVal.is_forbidden;
        this.getCheckedId(newVal.power_arr);
      }
    },
    mounted() {
      this.type=this.$route.query.active;
      // this.getUserAccessLists({type:this.$route.query.active});
      if (this.positionId) this.getPositionDetail(this.positionId);
    },
    methods:{
      ...mapActions(['getUserAccessLists','getPositionDetail','addEditPosition']),
      //添加-编辑职位信息
      submitForm() {
        //取出全选的子节点
        let allChecked = this.$refs.tree.getCheckedKeys();
        //取出半选的父节点
        let halfChecked = this.$refs.tree.getHalfCheckedKeys();
        let powerArr = allChecked.concat(halfChecked);

        if (!this.name) { this._alert('请填写职位名称',null,'error'); return }
        if (!this.type&&this.userInfo.type==99) { this._alert('请选择所属身份',null,'error'); return }
        if (powerArr.length <= 0) { this._alert('请设置职位权限',null,'error'); return }
        this._confirm('确定提交么？',() => {
          let data = {
            name: this.name,
            remarks: this.remarks,
            power_arr: powerArr,
            type:this.type
          }
          if (this.positionId) data.position_id = this.positionId;
          // if (this.userInfo.type === 99) { data.is_forbidden = this.is_forbidden; data.type = this.$route.query.active; }
          this.addEditPosition({
            type: this.positionId ? 'edit' : 'add',
            data,
            successFun:()=>{
              this.$router.push({name: 'PositionManage',query:{tab:this.type}})
            }
          })
        })
      },
      /*获取职位已经设置的权限数组key值*/
      //递归获取到所有的id，并删除父级id
      getCheckedId(posiArr) {
        posiArr.forEach(item => {
          if (!item.children || !item.children.length) this.positionArr.push(item.id);
          if (item.children) this.getCheckedId(item.children)
        });
        this.$refs.tree.setCheckedKeys(this.positionArr);
      },
    }
  }
</script>
